<template>
  <div class="connexionuser-list">
    <Toolbar/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-account-key</v-icon>{{$t('administration.user.connexionusers')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ConnexionUserFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.date" slot-scope="{ item }">
                  {{ formatDateTime(item['date'], 'long') }}
                </template>

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ConnexionUserFilterForm from '../../components/connexionuser/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ConnexionUserList',
  servicePrefix: 'ConnexionUser',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ConnexionUserFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('administration.user.ipadress'), value: 'ipAdress' },
        { text: this.$t('administration.user.login'), value: 'login' },
        { text: this.$t('administration.user.date'), value: 'date' },
        { text: this.$t('administration.user.failed'), value: 'failed' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('connexionuser', {
      items: 'list'
    }),
    ...mapFields('connexionuser', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('connexionuser', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
